/** @format */

import { useCallback, useState } from "react";

export const useFormModal = () => {
  const [open, setOpen] = useState<any>(false);
  const [initialData, setInitialData] = useState<any>(null);
  const [initialListData, setInitialListData] = useState<any>([]);

  const openModal = useCallback(() => {
    setInitialData(null);
    setOpen(true);
  }, []);

  const setListData = useCallback((data: any) => {
    setInitialListData(data);
  }, []);

  const openWithInitialData = useCallback((data: any) => {
    setInitialData(data);
    setOpen(true);
  }, []);

  const openWithInitialListData = useCallback((data: any, list: any) => {
    setInitialListData(list);
    setOpen(true);
  }, []);

  const openWithInitialAll = useCallback((data: any, list: any) => {
    setInitialData(data);
    setInitialListData(list);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
    setInitialData(null);
    setInitialListData([]);
  }, []);

  return {
    open,
    initialData,
    initialListData,
    setListData,
    openModal,
    openWithInitialData,
    openWithInitialAll,
    openWithInitialListData,
    closeModal,
  };
};
